import { register } from "@rill/loader";

register(
  {
    name: "listCustomMetrics",
    meta: ["custom-metric"],
    ttl: "2 seconds",
  },
  async ({ api, locals }, opts = {}) => {
    const organizationCoach = locals.query.organizationCoach || undefined;  
    let query = {
      limit: false,
      sort: { date: -1 },
      fields: ["_id", "date", "name"],
      proxyAthlete: opts.proxyAthlete,
    };
    if (organizationCoach) {
      query = { ...query, organizationCoach };
    }
    const res = await api("custom-metric", {
      query,
    });

    return await res.json();
  }
);

register(
  {
    name: "calendarMetrics",
    meta: ["no-bust", "exercise"],
    ttl: "2 hours",
  },
  async ({ api }, { athlete, type, exercise }) => {
    const res = await api("calendar-metrics", {
      query: {
        athlete,
        type,
        exercise,
      },
    });
    return await res.json();
  }
);

register(
  {
    name: "editCustomMetric",
    meta: ["custom-metric"],
    ttl: "2 seconds",
  },
  async ({ api, assert }, { customMetric, proxyAthlete }) => {
    if (!customMetric) return {};
    const res = await api("custom-metric", {
      query: { _id: customMetric, proxyAthlete },
    });
    const doc = (await res.json())[0] || {};
    assert(doc, 400, "Unable to find custom metric, it may have been deleted.");
    return doc;
  }
);

register(
  {
    name: "viewCustomMetric",
    meta: ["custom-metric", "exercise"],
    ttl: "2 seconds",
  },
  async (
    { api, momentTZ },
    { customMetric, start, end, period, proxyAthlete }
  ) => {
    start = momentTZ(start).toDate();
    end = momentTZ(end).toDate();
    return await (
      await api("view-custom-metric", {
        query: { customMetric, start, end, period, proxyAthlete },
      })
    ).json();
  }
);
